import { Loader, loaderStylesSpinnerXLarge } from '@h2oai/ui-kit';
import type { ReactNode } from 'react';

import { useAuthzPermissions } from '../../../authz/hooks/useAuthzPermissions';
import { Error403Page } from '../../ErrorPage';
import type { AuthzPermission } from '../routeDefinitions';

interface RequireAuthzPermissionProps {
  children: ReactNode;
  /** User must have at least ONE of these permissions (OR logic) */
  permissionOR?: AuthzPermission[];
  /** User must have ALL of these permissions (AND logic) */
  permissionAND?: AuthzPermission[];
}

export const RequireAuthzPermission = (props: RequireAuthzPermissionProps) => {
  const { children, permissionOR = [], permissionAND = [] } = props;
  const orResults = useAuthzPermissions(permissionOR);
  const andResults = useAuthzPermissions(permissionAND);

  if (orResults.isLoading || andResults.isLoading) {
    return <Loader styles={loaderStylesSpinnerXLarge} label="Checking permissions..." />;
  }

  // Check OR: at least one must be granted
  if (permissionOR.length > 0 && !orResults.results.some(Boolean)) return <Error403Page />;

  // Check AND: all must be granted
  if (permissionAND.length > 0 && !andResults.results.every(Boolean)) return <Error403Page />;

  return <>{children}</>;
};
